import React from 'react';
import { ErrorCodeContainer, ErrorLabel, ErrorWrapper } from 'pages/Error/Error.styled';
import { useLocation } from "react-router-dom";
import { FormattedMessage as Translate } from 'react-intl'

interface ErrorPageProps {
  isDefault?: boolean
}

function Error({isDefault}: ErrorPageProps) {

    const location = useLocation();
    const codeError = location?.state?.code ?? 404;

    return (
        <ErrorWrapper data-testid="Error">

            {codeError &&
                <ErrorCodeContainer>{codeError}</ErrorCodeContainer>
            }

            {codeError && codeError !== 404 &&
                <ErrorLabel>
                    <Translate id='Oups !' defaultMessage='Oups !'/>
                </ErrorLabel>
            }

            {
                codeError && codeError === 404 &&
                <ErrorLabel>
                    <Translate
                        id="Nous n'avons pas trouvé de lien de partage associé à cet id"
                        defaultMessage="Nous n'avons pas trouvé de lien de partage associé à cet id"/>

                </ErrorLabel>
            }
        </ErrorWrapper>
    )
};

export default Error;
